import { apiGet } from "./client.js";
import { ApiCallError } from "./client.js";
import type {
  RecurringRunSummary,
  RecurringChangeSummary,
} from "./product-types.js";
import type { RecurringAlertSummary } from "@accessimonitor/contracts";

export async function getLatestRecurring(
  websiteId: string,
): Promise<RecurringRunSummary | null> {
  return apiGet<RecurringRunSummary | null>(
    `/websites/${websiteId}/recurring`,
  );
}

export async function getRecurringById(
  websiteId: string,
  runId: string,
): Promise<RecurringRunSummary | null> {
  try {
    return await apiGet<RecurringRunSummary>(
      `/websites/${websiteId}/recurring/${runId}`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}

export async function getRecurringChanges(
  websiteId: string,
  runId: string,
): Promise<RecurringChangeSummary | null> {
  try {
    return await apiGet<RecurringChangeSummary>(
      `/websites/${websiteId}/recurring/${runId}/changes`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}

export async function listRecurringRuns(
  websiteId: string,
): Promise<RecurringRunSummary[]> {
  try {
    return await apiGet<RecurringRunSummary[]>(
      `/websites/${websiteId}/recurring/list`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return [];
    throw err;
  }
}

export async function getRecurringAlert(
  websiteId: string,
  runId: string,
): Promise<RecurringAlertSummary | null> {
  try {
    return await apiGet<RecurringAlertSummary>(
      `/websites/${websiteId}/recurring/${runId}/alert`,
    );
  } catch (err) {
    if (err instanceof ApiCallError && err.status === 404) return null;
    throw err;
  }
}
